export const OlympianTeam = [
    { id: 1, name: 'Donna Clarke', titles: ['Olympian' ,'CLUB CEO/HEAD COACH', 'Hurdles / Multi Events Specialist', 'NCCP CERTIFIED'], image: '/images/creatives/donna.svg'},
    { id: 2, name: 'Nikkita Holder', titles: ['Olympian' ,'Head Coach', 'Elementary Kids Program'], image: '/images/creatives/team-1.png'},
    { id: 3, name: 'Gavin Smellie', titles: ['Olympian', 'Sprints Coach'], image: '/images/creatives/team-4.png'}, 
]